import { CURRENT_USER } from 'common/actions';

const initialState = {};

export const currentUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case CURRENT_USER:
      return action.payload.currentUser;

    default:
      return state;
  }
};
